import { CacheLanguage } from '@zk/framework-vue';
const interpolate = /\${(.+?)}/g;

export default {
  install(Vue) {
    Vue.prototype.$td = function (value, defaultValue) {
      return value || defaultValue;
    };
    Vue.prototype.$tr = function (value, defaultValue) {
      if (value) {
        const b = interpolate.test(value);
        if (b) {
          return value.replace(interpolate, (_, $1) => this.$td(this.$t(CacheLanguage.replaceKey($1)), defaultValue));
        }
      }
      return this.$td(value, defaultValue);
    };
  }
};
